import { URLRoutes } from "../enums/Routing";
import { ILocation } from "../interfaces/History";

export const getLoginRouteWithRedirect = ({ pathname, search }: ILocation) => {
  return `${URLRoutes.Login}?redirect=${pathname}${search}`;
};
